import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import { setCategoryIdAction } from 'store/category/slice';
import sanitiseXSS from 'utils/sanitiseXSS';
import { setEncPublicDesignIdAction } from '../slice';

interface ProductPageRouteParams {
  slug: string;
  cid: string;
  design_id: string;
}

const setParamsFromQueryStringServerOperation =
  (routerParams: ProductPageRouteParams | any, queryString: any) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    // eslint-disable-next-line no-console
    console.log(queryString);
    const safeRouterParams = sanitiseXSS(routerParams) as ProductPageRouteParams;
    dispatch(setCategoryIdAction(Number(safeRouterParams.cid)));
    dispatch(setEncPublicDesignIdAction(safeRouterParams.design_id));
  };

export default setParamsFromQueryStringServerOperation;
